<template>
  <div class="container_left">
    <el-card class="box-card">
      <el-row>
        <el-col :span="12">
          <div class="real_account" :class="$store.state.listType == 1 ? 'is-active' : ''" @click="_changeAcc(1)">
            <span class="icon_acc"><img src="@/assets/image/real_icon.png"/></span>
            <span class="icon_text">{{ $t('home.racc') }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="real_account demo_account" :class="$store.state.listType == 0 ? 'is-active' : ''" @click="_changeAcc(0)">
            <span class="icon_acc"><img src="@/assets/image/demo_icon.png"/></span>
            <span class="icon_text">{{ $t('home.dacc') }}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card left-main">
      <el-row>
        <el-col :span="24">
          <el-menu
            ref="leftMenu"
            :default-active="$route.path"
            :default-openeds="[$store.state.leftActive]"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            :unique-opened="true"
          >
            <template v-for="(item, index) in leftList">
              <el-menu-item
                ref="leftHome"
                :index="item.children[0].path"
                @click="_routerChange(item.children[0].path, 'home')"
                class="_index_link"
                v-if="index == 0"
              >
                <i :class="item.meta.icon"></i>
                <span slot="title">{{ $t(item.meta.title) }}</span>
              </el-menu-item>
              <el-submenu :index="item.children[0].path" v-if="index > 0 && item && index < 7">
                <template slot="title">
                  <i :class="item.meta.icon"></i>
                  <span slot="title">{{ $t(item.meta.title) }}</span>
                </template>
                <el-menu-item-group v-if="index > 0">
                  <template
                    v-for="(childrenItem, childrenIndex) in item.children"
                    v-if="
                      $store.state.listType == 0
                        ? childrenItem.meta.pathWay == '3-1' ||
                          childrenItem.meta.pathWay == '3-3' ||
                          childrenItem.meta.pathWay == '4-1' ||
                          childrenItem.meta.pathWay == '6-4'
                        : index == '3'
                        ? $store.getters.authItem.indexOf(childrenItem.meta.title) >= 0
                          ? 1
                          : 0
                        : 1
                    "
                  >
                    <template v-if="$store.state.userInfo.jfUser && $store.state.userInfo.jfUser.jfUserBindcard.issueCountry == '1'">
                      <el-menu-item v-if="!childrenItem.meta.hide" @click="_routerChange(childrenItem.path)" :index="childrenItem.path">{{
                        $t(childrenItem.meta.title)
                      }}</el-menu-item>
                      <!-- <el-menu-item v-else @click="_routerChange(childrenItem.path)" :index="childrenItem.path">{{$t(childrenItem.meta.title)}}</el-menu-item> -->
                    </template>
                    <template v-else>
                      <template v-if="childrenItem.name !== 'buildphone'">
                        <el-menu-item v-if="!childrenItem.meta.hide" @click="_routerChange(childrenItem.path)" :index="childrenItem.path">{{
                          $t(childrenItem.meta.title)
                        }}</el-menu-item>
                      </template>
                    </template>
                  </template>
                </el-menu-item-group>
              </el-submenu>
              <el-menu-item
                :index="item.children[0].path"
                @click="_routerChange(item.children[0].path, 'activity')"
                class="_index_link_up"
                v-if="item && index === 7"
              >
                <i :class="item.meta.icon"></i>
                <span slot="title">{{ $t(item.meta.title) }}</span>
              </el-menu-item>
            </template>
            <el-menu-item v-if="varietyType == 1">
              <a :href="jyyUrl" target="_blank" style="display:block;text-decoration:none">
                <i class="uc-menu-icon-jyxx"></i>
                <span slot="title">交易员计划</span>
              </a>
            </el-menu-item>
          </el-menu>
        </el-col>
      </el-row>
    </el-card>
    <bind-box @changeAcc="_changeAcc"></bind-box>
  </div>
</template>
<script>
import { base64 } from '@/utils'
import { login } from '@/api'
import bindBox from '@/views/common/bindBox'
import { routers, enrouters } from '@/router/router.js'
export default {
  data() {
    return {
      leftList: [],
      currentActive: 0,
      changeIndex: 0,
      jyyUrl:'http://traderuc.drgjhk.com?token='+ localStorage.getItem('_token')
    }
  },
  //测试地址 http://drua.rlagent.lan
  //线上地址 https://traderuc.drgjhk.com
  components: {
    bindBox,
  },
  methods: {
    handleOpen(key, keyPath) {
      this.$store.commit('setLeftActive', key)
    },
    //切换账户
    _changeAcc(i) {
      // 当前用户的开户情况 0只有模拟 1只有真实 2都有
      if (i != this.$store.state.listType && this.changeIndex === 0) {
        this.changeIndex = 1
        let params = {
          type: i,
        }
        login.switch(params).then(async res => {
          if (res.IsSuccess) {
            localStorage.setItem('_token', res.Token)
            $('._index_link').trigger('click')
            this.$store.commit('setListType', i)
            this.$refs['leftMenu'].close(this.$store.state.leftActive)
            this.leftList = this.$store.getters.currenLeftList
            console.log(JSON.parse(JSON.stringify(this.leftList)))
            let userInfo = res.Data.jfSimulatorAccount ? res.Data.jfSimulatorAccount : res.Data.jfAccount

            //this.$store.commit('setUserInfo', userInfo)
            if (userInfo.role) {
              this.$store.commit('setUserRole', userInfo.role)
            }
            //获取用户信息
            if (i == 1) {
              //切换为真实账号
              await this.$store.dispatch('getUserInfo', {
                type: userInfo.type,
                lastLoginTime: userInfo.lastLoginTime,
              })
            } else {
              await this.$store.dispatch('getUserInfo', {
                type: userInfo.type,
              })
            }
            // console.log(this.$store.state.userInfo)
          } else {
            this.$alert(this.$t('fx.nodemoac'), this.$t('commiss.tips'), {
              confirmButtonText: this.$t('bank.Confirm'),
            })
            // if (i == 1) {
            //   this.$store.commit('setBindBoxStatue', 1)
            // } else {
            //   this.$store.commit('setBindBoxStatue', 2)
            // }
          }
          setTimeout(() => {
            this.changeIndex = 0
          }, 300)
        })
      }
    },
    // left_postion
    _leftPostion() {
      const winHeight = window.innerHeight
      const leftOffset = $('.left-main').offset().top
      $(window).scroll(function() {
        const scrollH = $(window).scrollTop()
        const leftHeight = $('.left-main').height()
        const rightWrap = $('.container').height()
        if (rightWrap > leftHeight) {
          if (scrollH >= leftOffset) {
            $('.left-main').css({ position: 'fixed', top: '5px' })
          } else {
            $('.left-main').css({ position: 'static' })
          }
        }
      })
    },
    // 生成左侧list
    _createLeftList() {
      console.log(JSON.parse(JSON.stringify(routers)), 9988)
      this.$store.commit('setLeftList', routers)
    },
    _routerChange(path, flag) {
      if (flag === 'home' || flag === 'upGrade') {
        this.$refs['leftMenu'].close(this.$store.state.leftActive)
        if (flag === 'home') {
          this.$store.commit('setLeftActive', 1)
        } else {
          this.$store.commit('setLeftActive', 7)
        }
      }
      this.$router.push({
        path,
      })
    },
  },
  mounted() {
    this.varietyType =
      localStorage.varietyType || (this.$store.state.userInfo && this.$store.state.userInfo.jfUser && this.$store.state.userInfo.jfUser.varietyType)
    this._leftPostion()
    this._createLeftList()
    this.leftList = this.$store.getters.currenLeftList
    this.leftList[2].children = this.leftList[2].children.filter(a => {
      return a.meta.isShow !== '9'
    })
    if (
      this.$store.state.userInfo &&
      this.$store.state.userInfo.jfUser &&
      this.$store.state.userInfo.jfUser.agentLevel == 0 &&
      this.$store.state.userInfo.jfUser.settlementMethod == 1
    ) {
      const children = [...this.$store.getters.currenLeftList[1].children]
      this.leftList[1].children = children
    } else {
      const children = [...this.$store.getters.currenLeftList[1].children]
      this.leftList[1].children = children.slice(0, children.length - 3)
    }
  },
  watch: {
    '$store.state.fundsAuth'(newV, oldV) {
      this.leftList = this.$store.getters.currenLeftList
    },
    $route(newV, oldV) {
      let pName = newV.matched[0].meta.title
      let sName = newV.matched[1].meta.title
      let pathWay = newV.matched[0].meta.pathWay
      let breadParam = {
        oB: pName,
        topPath: pathWay,
        children: [
          {
            name: sName,
            path: newV.path,
          },
        ],
      }
      this.$store.commit('setBread', breadParam)
    },
  },
}
</script>

<style lang="scss">
@import '~scss/common/left.scss';
</style>



// WEBPACK FOOTER //
// src/views/common/left.vue